export default __webpack_public_path__ + "84f68f2e7ee3c48c1409b597f9991856.svg";